import React, { Component } from 'react';
import './style.css';
import {Link} from 'react-router-dom';
import Icon from 'react-icons-kit';
import {androidDelete} from 'react-icons-kit/ionicons/androidDelete';
import {eye} from 'react-icons-kit/ionicons/eye';

class UserDemographicsDataList extends Component {
  constructor(props){
    super(props)

    this.queryString = window.location.href;
    this.uid =this.queryString.split('&UID=')[1];  //participant id 
    this.state = {
        uid: this.uid,
    }
  }

  
  userDemoQuestionsAnsList(data){
   this.props.showDataDemographics(data.cat_id , this.state.uid)
  }

  goBackScreen(){
    window.history.back();
  }


  render(){

    let couponsDataList = "";
    if(this.props.userDemographicsDataSuccess){
    if(this.props.userDemographicsData && this.props.userDemographicsData.length > 0){
        let demographics = this.props.userDemographicsData;
        couponsDataList = Object.keys(demographics).map((item, index) => {
        let demographicsItem = demographics[item];

        return <tr key={index} >
            <td style={{textAlign : "center"}}>{index+1}</td>
            <td >{demographicsItem.questionText}</td>
            <td>{demographicsItem.optionText}</td>
          </tr>
          });
    }else{
        couponsDataList = "No data"
    }
  }

  return (<div className = "userlist">
  <div className = "userlistbackground">
        <div className = "usertable"><h1>Demographics question List</h1></div>
        <button  className = "backbutton" onClick={this.goBackScreen}>Back</button>
        <div className = "autoscroll">
        <table className = "userDemoategoryTable">
        
          <thead>
            <tr >
              <th style={{width: "10%"}}>Sr.No.</th>
              <th>Questions</th>
              <th>Answer</th>
            </tr>
          </thead>
            <tbody> 
              {couponsDataList}  
            </tbody>
        </table>
        </div>
        </div>
        </div>
        
    );
  }
}
export default UserDemographicsDataList;



// WEBPACK FOOTER //
// ./src/components/country/userDemographicsData.js